import axios from '../requester';

export const ACCOUNTS_ROUTES = /** @type {const} */ ({
  ME: '/api/account/me',
  SWITCH_ORG: '/api/account/switch_org'
});

export const getAccount = async () => {
  const { data } = await axios.get(ACCOUNTS_ROUTES.ME);
  return data;
};

export const switchOrg = async params => {
  const res = await axios.get(ACCOUNTS_ROUTES.SWITCH_ORG, { params });
  return res.data;
};
